import { InventoryWarningInfo, getInventoryWarningList } from "@/services/api/wms";
import to from "@/utils/to";
import { computed, observable, makeObservable, actionBound } from "mobx";

/**
 * 以下场景需要load库存预警信息
 * 1.展示库存预警信息
 * 2.打印快递单弹窗
 */
class WarehouseWarningStore {
    constructor() {
        makeObservable(this, {
            inventoryWarningList: observable,
            loaded: observable,
            loading: observable,
            inventoryWarningMapping: computed,
            load: actionBound,
            ensure: actionBound,
            getIsInventoryWarning: actionBound,
        });
    }

    inventoryWarningList: InventoryWarningInfo[] = [];

    loaded = false;

    loading = false;

    get inventoryWarningMapping() {
        const map = new Map<string, InventoryWarningInfo>();

        this.inventoryWarningList.forEach((item) => {
            map.set(item.externalId, item);
        });

        return map;
    }

    async load() {
        if (this.loading) return;

        this.loading = true;
        const [_, inventoryWarningList] = await to(getInventoryWarningList());

        if (inventoryWarningList) {
            this.loaded = true;
            this.inventoryWarningList = inventoryWarningList;
        }

        this.loading = false;
    }

    async ensure() {
        if (this.loaded) return;

        await this.load();
    }

    /** 优先使用SkuExternalId,其次ProductExternalId */
    getIsInventoryWarning(externalId: string) {
        /** 前端再兜底计算一次 */

        if (!this.inventoryWarningList?.length) return false;

        const inventoryWarningInfo = this.inventoryWarningMapping.get(externalId);

        if (!inventoryWarningInfo) return false;

        const restInventory = inventoryWarningInfo.totalInventory - inventoryWarningInfo.occupyInventory;

        return restInventory <= inventoryWarningInfo.inventoryThreshold;
    }
}

export default WarehouseWarningStore;
